import { persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import categoryApi from "../services/categoryApi";
import customerApi from "../services/customerApi";
import productApi from "../services/productApi";
import SearchApi from "../services/searchApi";
import userApi from "../services/userApi";

import persistReducer from "redux-persist/es/persistReducer";
import { accountReducer } from "../features/accountSlice";
import { adjustReducer } from "../features/adjustSlice";
import { damageReducer } from "../features/damageSlice";
import { ecomSalesReducer } from "../features/ecomSalesSlice";
import { ecomSaleUpdateReducer } from "../features/ecomSaleUpdateSlice";
import { grnReducer } from "../features/grnSlice";
import { importReducer } from "../features/importSlice";
import { languageReducer } from "../features/languageSlice";
import { paymentReducer } from "../features/paymentSlice";
import { posCollectionReducer } from "../features/posCollectionSlice";
import { posReducer } from "../features/posSlice";
import { priceUpdateReducer } from "../features/priceUpdateSlice";
import { productPriceListReducer } from "../features/ProductpriceListSlice";
import { productPriceReducer } from "../features/productPriceSlice";
import { purchaseReducer } from "../features/purchaseSlice";
import { rtvReducer } from "../features/rtvSlice";
import { smsReducer } from "../features/smsSlice";
import { supplierReducer } from "../features/supplierSlice";
import { tpnReducer } from "../features/tpnSlice";
import accountApi from "../services/accountApi";
import accountHeadApi from "../services/accountHeadApi";
import AdjustApi from "../services/adjustApi";
import brandApi from "../services/brandApi";
import DamageApi from "../services/damageApi";
import ecomSaleApi from "../services/ecomApi";
import grnApi from "../services/grnApi";
import groupApi from "../services/groupApi";
import InventoryApi from "../services/inventoryApi";
import InventoryCountApi from "../services/inventoryCountApi";
import paymentApi from "../services/paymentApi";
import PosCollectionApi from "../services/posCollectionApi";
import priceApi from "../services/priceApi";
import purchasApi from "../services/purchasApi";
import rtvApi from "../services/rtvApi";
import saleApi from "../services/saleApi";
import supplierApi from "../services/supplierApi";
import tpnApi from "../services/tpnApi";
import unitApi from "../services/unitApi";
import warehouseApi from "../services/warehouseApi";
import ReportsApi from "../services/reportsApi";
import CustomerGroupApi from "../services/customerGroupApi";
import settingsApi from "../services/settingsApi";
import RedxApi from "../services/redxApi";


// Combine all reducers
const rootReducer = combineReducers({
  [userApi.reducerPath]: userApi.reducer,
  [categoryApi.reducerPath]: categoryApi.reducer,
  [productApi.reducerPath]: productApi.reducer,
  [customerApi.reducerPath]: customerApi.reducer,
  [warehouseApi.reducerPath]: warehouseApi.reducer,
  [SearchApi.reducerPath]: SearchApi.reducer,
  [supplierApi.reducerPath]: supplierApi.reducer,
  [priceApi.reducerPath]: priceApi.reducer,
  [grnApi.reducerPath]: grnApi.reducer,
  [purchasApi.reducerPath]: purchasApi.reducer,
  [DamageApi.reducerPath]: DamageApi.reducer,
  [AdjustApi.reducerPath]: AdjustApi.reducer,
  [InventoryApi.reducerPath]: InventoryApi.reducer,
  [InventoryCountApi.reducerPath]: InventoryCountApi.reducer,
  [rtvApi.reducerPath]: rtvApi.reducer,
  [RedxApi.reducerPath]: RedxApi.reducer,
  [saleApi.reducerPath]: saleApi.reducer,
  [ReportsApi.reducerPath]: ReportsApi.reducer,
  [ecomSaleApi.reducerPath]: ecomSaleApi.reducer,
  [tpnApi.reducerPath]: tpnApi.reducer,
  [unitApi.reducerPath]: unitApi.reducer,
  [brandApi.reducerPath]: brandApi.reducer,
  [settingsApi.reducerPath]: settingsApi.reducer,
  [groupApi.reducerPath]: groupApi.reducer,
  [CustomerGroupApi.reducerPath]: CustomerGroupApi.reducer,
  [accountHeadApi.reducerPath]: accountHeadApi.reducer,
  [accountApi.reducerPath]: accountApi.reducer,
  [paymentApi.reducerPath]: paymentApi.reducer,
  [PosCollectionApi.reducerPath]: PosCollectionApi.reducer,
  supplierReducer,
  grnReducer,
  posReducer,
  tpnReducer,
  purchaseReducer,
  rtvReducer,
  damageReducer,
  adjustReducer,
  smsReducer,
  productPriceReducer,
  ecomSalesReducer,
  ecomSaleUpdateReducer,
  priceUpdateReducer,
  accountReducer,
  productPriceListReducer,
  paymentReducer,
  posCollectionReducer,
  languageReducer,
  importReducer,
});

// Redux Persist Config
const persistConfig = {
  key: "AamarDokan",
  storage,
  whitelist: [
    "languageReducer",
    "importReducer",
    "supplierReducer",
    "accountReducer",
    "posReducer",
  ], // Add reducers you want to persist
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure Store
const Store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable warnings for non-serializable actions
    })
      .concat(userApi.middleware)
      .concat(paymentApi.middleware)
      .concat(categoryApi.middleware)
      .concat(productApi.middleware)
      .concat(customerApi.middleware)
      .concat(warehouseApi.middleware)
      .concat(unitApi.middleware)
      .concat(brandApi.middleware)
      .concat(settingsApi.middleware)
      .concat(groupApi.middleware)
      .concat(CustomerGroupApi.middleware)
      .concat(supplierApi.middleware)
      .concat(priceApi.middleware)
      .concat(SearchApi.middleware)
      .concat(purchasApi.middleware)
      .concat(saleApi.middleware)
      .concat(ReportsApi.middleware)
      .concat(ecomSaleApi.middleware)
      .concat(tpnApi.middleware)
      .concat(DamageApi.middleware)
      .concat(AdjustApi.middleware)
      .concat(rtvApi.middleware)
      .concat(RedxApi.middleware)
      .concat(grnApi.middleware)
      .concat(InventoryApi.middleware)
      .concat(priceApi.middleware)
      .concat(InventoryCountApi.middleware)
      .concat(accountHeadApi.middleware)
      .concat(accountApi.middleware)
      .concat(PosCollectionApi.middleware),
});

export const persistor = persistStore(Store);

export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;

export default Store;
